// Hook for enriching monitors with real-time values
import { MonitorService } from '../../types';
import {
  usePerformanceDataParser,
  useServiceMatcher,
} from './usePerformanceData';
import { useMemo } from 'react';

export const useMonitorsWithValues = (
  monitors: MonitorService[],
  performanceData: any[]
) => {
  const parsePerformanceData = usePerformanceDataParser();
  const findMatchingService = useServiceMatcher(performanceData);

  return useMemo(() => {
    if (!monitors.length || !performanceData) return [];

    return monitors
      .map((monitor) =>
        enrichMonitorWithValue(
          monitor,
          findMatchingService,
          parsePerformanceData
        )
      )
      .filter((monitor) => monitor.value !== undefined);
  }, [monitors, performanceData, findMatchingService, parsePerformanceData]);
};

const enrichMonitorWithValue = (
  monitor: MonitorService,
  findMatchingService: (monitor: MonitorService) => any,
  parsePerformanceData: (
    perfData: string,
    monitor: MonitorService
  ) => number | string
) => {
  const serviceData = findMatchingService(monitor);

  if (serviceData?.extensions?.perf_data) {
    const currentValue = parsePerformanceData(
      serviceData.extensions.perf_data,
      monitor
    );
    return { ...monitor, value: currentValue };
  }

  return monitor;
};
